import Y2018CoalizioniInfoColori from '@/data/2018/2018-coalizioni-info-colori.json';
import Y2018PartitiListeColori from '@/data/2018/2018-partiti-liste-colori.json';
import CameraCoalizioniInfoColori from '@/data/2022/camera-coalizioni-info-colori.json';
import PartitiListeColoriCamera from '@/data/2022/camera-partiti-liste-colori.json';
import {
  default as GenLazioCoalizioniInfoColori,
  default as SoleAgiLazioCoalizioniInfoColori,
} from '@/data/2023/general/2023-lazio-coalizioni-info-colori.json';
import {
  default as GenLazioPartitiListeColori,
  default as SoleAgiLazioPartitiListeColori,
} from '@/data/2023/general/2023-lazio-partiti-liste-colori.json';
import {
  default as GenLombardiaCoalizioniInfoColori,
  default as SoleAgiLombardiaCoalizioniInfoColori,
} from '@/data/2023/general/2023-lombardia-coalizioni-info-colori.json';
import {
  default as GenLombardiaPartitiListeColori,
  default as SoleAgiLombardiaPartitiListeColori,
} from '@/data/2023/general/2023-lombardia-partiti-liste-colori.json';
import Config, { Clients } from '@/lib/config';
import { DataLevel, Region, Year } from '@/lib/model';
import { parsePercentage } from './helpers';

import { default as AbruzzoCoalizioniInfoColori2019 } from '@/data/2019/2019-abruzzo-coalizioni-info-colori.json';
import { default as AbruzzoPartitiListeColori2019 } from '@/data/2019/2019-abruzzo-partiti-liste-colori.json';

import { default as AbruzzoCoalizioniInfoColori2024 } from '@/data/2024/2024-abruzzo-coalizioni-info-colori.json';
import { default as AbruzzoPartitiListeColori2024 } from '@/data/2024/2024-abruzzo-partiti-liste-colori.json';
import { formatCapitalize } from '@/utils/format-capitalize.util';

export const getPartyList = (year: Year, region: Region) => {
  let list = PartitiListeColoriCamera;

  if (year === Year.Y2023) {
    switch (region) {
      case Region.LAZIO:
        list = GenLazioPartitiListeColori;
        break;
      case Region.LOMBARDIA:
        list = GenLombardiaPartitiListeColori;
        break;
      case Region.ABRUZZO:
        list = GenLazioPartitiListeColori;
        break;
      case Region.ALL:
        list = GenLazioPartitiListeColori;
        break;
    }

    // different color mapping for 2023 - Sole - Agi
    if (Config.client === Clients.SOLEAGI) {
      list =
        region === Region.LAZIO
          ? SoleAgiLazioPartitiListeColori
          : SoleAgiLombardiaPartitiListeColori;
    }
  } else if (year === Year.Y2018) {
    list = Y2018PartitiListeColori;
  } else if (year === Year.Y2019) {
    switch (region) {
      case Region.ABRUZZO:
        list = AbruzzoPartitiListeColori2019;
        break;
      case Region.ALL:
        list = AbruzzoPartitiListeColori2019;
        break;
    }
  } else if (year === Year.Y2024) {
    switch (region) {
      case Region.ABRUZZO:
        list = AbruzzoPartitiListeColori2024;
        break;
      case Region.ALL:
        list = AbruzzoPartitiListeColori2024;
        break;
    }
  }

  return list;
};

export const getCoalitionsList = (year: Year, region: Region) => {
  let list = CameraCoalizioniInfoColori;

  if (year === Year.Y2023) {
    switch (region) {
      case Region.LAZIO:
        list = GenLazioCoalizioniInfoColori;
        break;
      case Region.LOMBARDIA:
        list = GenLombardiaCoalizioniInfoColori;
        break;
      case Region.ABRUZZO:
        list = GenLazioCoalizioniInfoColori;
        break;
      case Region.ALL:
        list = GenLazioCoalizioniInfoColori;
        break;
    }

    // different color mapping for 2023 - Sole - Agi
    if (Config.client === Clients.SOLEAGI) {
      list =
        region === Region.LAZIO
          ? SoleAgiLazioCoalizioniInfoColori
          : SoleAgiLombardiaCoalizioniInfoColori;
    }
  } else if (year === Year.Y2018) {
    list = Y2018CoalizioniInfoColori;
  } else if (year === Year.Y2019) {
    switch (region) {
      case Region.ABRUZZO:
        list = AbruzzoCoalizioniInfoColori2019;
        break;
      case Region.ALL:
        list = AbruzzoCoalizioniInfoColori2019;
        break;
    }
  } else if (year === Year.Y2024) {
    switch (region) {
      case Region.ABRUZZO:
        list = AbruzzoCoalizioniInfoColori2024;
        break;
      case Region.ALL:
        list = AbruzzoCoalizioniInfoColori2024;
        break;
    }

    list = AbruzzoCoalizioniInfoColori2024;
  }

  return list;
};

export const getPartyColor = (year: Year, region: Region, pos: number) => {
  const list = getPartyList(year, region);
  return list.find(c => c.pos === pos)?.colore || '#D9D9D9';
};

export const getName = (
  year: Year,
  region: Region,
  isCoalition: boolean,
  o: any
) => {
  const parties = getPartyList(year, region);
  const coalitions = getCoalitionsList(year, region);

  if (isCoalition) {
    let coalition = coalitions.find(c => c.cod_coal === o?.pos);
    if (coalition !== undefined) {
      return coalition.coalizione;
    }
  }

  if (
    !parties.find(c => c.pos === o?.pos)?.desc_lis &&
    !parties.find(c => c.cod_coal === o?.pos)?.desc_lis
  ) {
    // debugger;
  }

  return (
    parties.find(c => c.pos === o?.pos)?.desc_lis ||
    parties.find(c => c.cod_coal === o?.pos)?.desc_lis ||
    'N/A'
  );
};

export const getFullNameCandidate = (
  year: Year,
  region: Region,
  isCoalition: boolean,
  o: any,
  isMultiCollegio = false
) => {
  const coalitions = getCoalitionsList(year, region);
  const is2018 = year === Year.Y2018;
  const is2022 = year === Year.Y2022;

  if (isCoalition) {
    let coal = coalitions.find(c => c.cod_coal === o?.pos);
    if (coal !== undefined) {
      if (!isMultiCollegio && !is2018) {
        if (o.cogn !== undefined) {
          return formatCapitalize(o.nome + ' ' + o.cogn);
        } else if (o.desc_pos !== undefined && !is2022) {
          return formatCapitalize(o.desc_pos);
        }
      }
    }
  }

  return null;
};

export const getMostraDettaglio = (year: Year, region: Region, pos: number) => {
  const coalitions = getCoalitionsList(year, region);

  return coalitions.find((c: any) => c.cod_coal === pos)?.mostraDettaglio;
};

export const getCoalitionColorByPartitoListaId = (
  year: Year,
  region: Region,
  pos: number
) => {
  const parties = getPartyList(year, region);
  const coalitions = getCoalitionsList(year, region);

  let party = parties.find(c => c.pos === pos);
  if (
    party?.cod_coal === 1 || // CENTROSINISTRA 2024
    party?.cod_coal === 2 ||
    party?.cod_coal === 5 ||
    party?.cod_coal === 22 ||
    party?.cod_coal === 17 ||
    party?.cod_coal === 27
  ) {
    // coalition color only if CENTRODESTRA or CENTROSINISTRA
    return (
      coalitions.find(c => c.cod_coal === party?.cod_coal)?.colore || '#D9D9D9'
    );
  }

  return party?.colore || '#D9D9D9';
};

/**
 *
 * @param year
 * @param region
 * @param level
 * @param coalition
 * @return {string} Colore
 */
export const getCoalitionColor = (
  year: Year,
  region: Region,
  level: DataLevel,
  coalition: any
): string => {
  const coalitions = getCoalitionsList(year, region);

  if (level === DataLevel.PROVINCIA) {
    if (
      ((year === Year.Y2018 ||
        (year === Year.Y2023 && region === Region.LAZIO)) &&
        coalition?.pos === 5) ||
      ((year === Year.Y2018 || year === Year.Y2023) && coalition?.pos === 2) ||
      (year === Year.Y2022 && coalition?.pos === 22) ||
      (year === Year.Y2018 && coalition?.pos === 15) ||
      (year === Year.Y2022 && coalition?.pos === 17) ||
      (year === Year.Y2019 && coalition?.pos === 22) ||
      (year === Year.Y2019 && coalition?.pos === 17) ||
      (year === Year.Y2023 &&
        region === Region.LOMBARDIA &&
        coalition?.pos === 1) ||
      (year === Year.Y2023 && coalition?.pos === 4)
    ) {
      return (
        coalitions.find(c => c.cod_coal === coalition?.pos)?.colore || '#D9D9D9'
      );
    }

    return getCoalitionColorByPartitoListaId(
      year,
      region,
      (coalition?.liste || [])[0]?.pos || 0
    );
  } else if (
    level === DataLevel.COMUNE &&
    !(year === Year.Y2022 && (coalition.pos === 17 || coalition.pos === 22)) &&
    !(year === Year.Y2019 && (coalition.pos === 17 || coalition.pos === 22)) &&
    !(
      year === Year.Y2018 &&
      (coalition.pos === 15 || coalition.pos === 5 || coalition.pos === 2)
    ) &&
    !(
      year === Year.Y2023 &&
      (coalition.pos === 2 ||
        coalition.pos === 4 ||
        (region === Region.LAZIO && coalition.pos === 5) ||
        (region === Region.LOMBARDIA && coalition?.pos === 1))
    ) &&
    !(year === Year.Y2024 && (coalition.pos === 2 || coalition.pos === 1))
  ) {
    return getPartyColor(year, region, (coalition?.liste || [])[0]?.pos || 0);
  } else {
    // default CIRCOSCRIZIONE
    return (
      coalitions?.find(c => c.cod_coal === coalition.pos)?.colore || '#D9D9D9'
    );
  }
};

export const generateGradientTable = <T>(list: T[], key: keyof T) => {
  if (!list.length) {
    return [];
  }

  let min = parsePercentage(`${list[0][key]}`);
  let max = parsePercentage(`${list[0][key]}`);

  list.forEach(c => {
    const check = parsePercentage(`${c[key]}`);

    if (check < min) {
      min = check;
    } else if (check > max) {
      max = check;
    }
  });

  const diff = max - min;
  const totalSteps = 7;
  const step = parseFloat((diff / totalSteps).toFixed(2));
  let prevValue = min;

  return Array.from({ length: totalSteps }).map((_, i) => {
    const opacity = parseFloat((0.15 * (i + 1)).toFixed(2));
    const value = i === totalSteps - 1 ? max : prevValue + step;
    prevValue = value;

    return {
      opacity: opacity > 1 ? 1 : opacity,
      value,
    };
  });
};
